import React from "react"
import "./StickyBar.less"
import getQueryParams from "../../utils/getQueryParams"
import LocationPageGetInTouchModal from "../LocationPageGetInTouchModal"

export default ({ showFilter = () => null }) => {
  const params = getQueryParams()
  return (
    <div className={"sticky-bar"}>
      <div className="container">
        <div className="row">
          <div
            className={"col-12 d-flex justify-content-end align-items-center"}
          >
            {!params.get("current_staff") && (
              <button className="btn btn-primary border" onClick={showFilter}>
                Select Team Size
              </button>
            )}
            <LocationPageGetInTouchModal />
          </div>
        </div>
      </div>
    </div>
  )
}
